import { Link } from "react-router-dom";
// import CustomSlider from "../Common/CustomSlider";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";

// import Swiper core and required modules
import { Autoplay, Navigation, Pagination } from 'swiper';

// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react/swiper-react";

// Import Swiper styles
import "swiper/swiper-bundle.min.css";
import "swiper/modules/navigation/navigation.min.css";
import "swiper/modules/pagination/pagination.min.css";

import { isMobile } from "react-device-detect";

function Accessories({ heading, componentData, getTargetUrl, showShopNow=false }) {
  
  const navigation_status = isMobile? false:true;  
  const slide_per_view = isMobile?2:3;

  // var settings = {
  //   className:"acc-crousel",
  //   dots: false,
  //   infinite: false,
  //   speed: 500,
  //   slidesToShow: 3,
  //   slidesToScroll: 1,
  //   initialSlide: 0,
  //   cssEase: "linear",
  //   mobileFirst: true,
  //   centerMode: true,
  //   responsive: [
  //     {
  //       breakpoint: 1024,
  //       settings: {
  //         slidesToShow: 3,
  //         slidesToScroll: 1,
  //         infinite: true,
  //         dots: false,
  //       },
  //     },
  //     {
  //       breakpoint: 600,
  //       settings: {
  //         slidesToShow: 1,
  //         slidesToScroll: 1,
  //         initialSlide: 0,
  //       },
  //     },
  //     {
  //       breakpoint: 480,
  //       settings: {
  //         slidesToShow: 1,
  //         slidesToScroll: 1,
  //       },
  //     },
  //   ],
  // };
  return (
    <div className="col-md-12">
      <div
        className={`main-heading-center ${
          heading === "WOMEN" ? "mt-60" : ""
        }`}
      >
        <h4 className="text-underline">{heading}</h4>
      </div>

      {/* <CustomSlider settings={settings}> */}
      <Swiper
        slidesPerView={slide_per_view}
        spaceBetween={20}
        centeredSlides={false}
        autoplay={{
          delay: 2500,
          disableOnInteraction: false,
        }}
        pagination={{
          clickable: true,
        }}
        navigation={navigation_status}
        loop={true}
        modules={[Autoplay, Pagination, Navigation]}
        className="mySwiper"                
      >
        {componentData.data?.map((data, index) => {
          return (            
            <div className="item" key={"acceblockdiv" + heading + index}>
              <div className="product-box-bordered">
              <SwiperSlide key={"acceblock" + heading + index}>
                <Link to={getTargetUrl(data)}>
                  <LazyLoadImage
                    alt={""}
                    effect="blur"
                    src={data.src || ""}
                    className="img-fluid mx-auto d-block"
                    style={{height: isMobile?"":"500px"}}
                  />
                </Link>
                {/* {showShopNow && (
                  <div className="text text-center">
                    <h6 className="text-black">
                      <Link to={getTargetUrl(data)}>{data.title || ""}</Link>
                    </h6>
                    <button
                      className="btn-bordered mt-35"
                      type="button"
                      onClick={() => navigate(getTargetUrl(data))}
                    >
                      Shop Now
                    </button>
                  </div>
                )} */}
                </SwiperSlide>
              </div>
            </div>            
          );
        })}
      </Swiper>  
      {/* </CustomSlider> */}
    </div>
  );
}

export default Accessories;
